import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { GlobalErrorHandlerService } from '../shared/services/global-error-handler.service';
import { ENDPOINTS } from '../shared/constants/url.constants';

export const PRESERVE_ORIGINAL_ERROR = new HttpContextToken<boolean>(() => false);

// Opt-in per-request flag: when set (alongside PRESERVE_ORIGINAL_ERROR), skips the
// generic "Error:xxx / Request failed" toast entirely for this request - use when the
// caller already shows its own specific, inline error message (e.g. reading
// responsemsg[].desc) and the generic toast would just be redundant noise on top of
// it. Does not affect any other request in the app.
export const SUPPRESS_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {

  const errorHandler = inject(GlobalErrorHandlerService);

  return next(req).pipe(
    catchError((error : HttpErrorResponse) => {
      // referral submission timeouts are handled by the caller (processing message + navigate out) instead of the generic alert
      if (error?.status === 504 && req.url === ENDPOINTS.SAVE_REFERRAL) {
        return throwError(() => error);
      }
      if (req.context.get(PRESERVE_ORIGINAL_ERROR)) {
        if (!req.context.get(SUPPRESS_ERROR_TOAST)) {
          errorHandler.handleError(error);
        }
        return throwError(() => error);
      }
      return throwError(()=>errorHandler.handleError(error));
    })
  );
};
